import { html, TemplateResult } from 'lit';
import { ifDefined } from 'lit/directives/if-defined.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import type { TefComs4csMicroFrontend } from '@src/components/tef-coms4cs';
import { comsStore } from '@src/state/ComsStore';
import { FeatureValueStore } from '@src/state/FeatureValueStore';

function featureLabel(this: TefComs4csMicroFrontend, feat: FeatureValueStore) {
  return feat.description === feat.title
    ? unsafeHTML(feat.title)
    : this.getTemplateFn('tooltipTemplate')(comsStore.config?.styleContext as string, feat.description, feat.title);
}

export function featureTemplate(
  this: TefComs4csMicroFrontend,
  feature: FeatureValueStore,
  deprecated: boolean,
): TemplateResult {
  return html`
    <tef-coms-multi-checkbox
      value="${ifDefined(feature.granted)}"
      @change=${(event: { detail: boolean; }) => { feature.change(event.detail); }}
      ?disabled="${(comsStore.identity?.readonly || deprecated) ?? false}"
    >
      <p>${/* eslint-disable-line */ featureLabel.bind(this)(feature)}</p>
    </tef-coms-multi-checkbox>
  `;
}
